module.exports = __webpack_public_path__ + "img/jpg.760142fb.png";